import { StyledWrapper } from './Divider.style';

export function Divider() {
  return <StyledWrapper />;
}
